import { House } from '@mui/icons-material';
import { FieldControllerTypes, IFormController } from '../../../components/form_v2/types';

export const insertCollectionFields = () => {
  const radioOptions = [
    { key: 'ΝΑΙ', value: true },
    { key: 'ΟΧΙ', value: false },
  ];
  const insertStep1Form: IFormController[] = [
    {
      control: FieldControllerTypes.input,
      label: 'Μοναδικός Κωδικός Συλλογής',
      name: 'collectionsUniqueCode',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Aναγνωριστικό Συλλογής',
      name: 'collectionsIdentifierUniqueCode',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Φορέας που ανήκει η Συλλογή',
      name: 'organisationsUniqueCode',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τίτλος Συλλογής',
      name: 'collectionsTitle',
      required: true,
      disabled: true
    },
    {
      control: FieldControllerTypes.input,
      label: 'Τίτλος Συλλογής στα Αγγλικά',
      name: 'collectionsEnTitle',
      required: true,
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Περιγραφή Συλλογής',
      name: 'collectionsDescription',
      required: true,
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Περιγραφή Συλλογής στα Αγγλικά',
      name: 'collectionEnDescription',
      required: true,
    },
    {
      control: FieldControllerTypes.radio,
      label: 'Εσωτερική',
      name: 'collectionInternalFlag',
      row: true,
      options: radioOptions
    },
    {
      control: FieldControllerTypes.input,
      label: 'Επιλεγμένη',
      name: 'collectionFeaturedFlag',
      placeholder: 'Τag ή ID',
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις Σχόλια Συλλογής',
      name: 'collectionsComments',
    },
    {
      control: FieldControllerTypes.textarea,
      label: 'Παρατηρήσεις Σχόλια Συλλογής στα Αγγλικά',
      name: 'collectionsCommentsEn',
    }
  ];
  const insertStep1 = {
    label: 'Βασικές Πληροφορίες Συλλογής',
    content: insertStep1Form,
    icon: <House/>
  };
  return [
    {...insertStep1}
  ];
};

export const createCollectionFields = (organisation_options: any) => {
  const step1Form = [
    [ {
      control: FieldControllerTypes.select,
      type: 'select',
      label: 'Επιλέξτε Φορέα',
      name: 'orgIdentifierCountryId',
      required: true,
      options: organisation_options
    },
    {
      control: FieldControllerTypes.input,
      type: 'input',
      label: 'Τίτλος Συλλογής',
      name: 'collectionsTitle',
      required: true,
    }]
  ];

  const step1 = {
    label: 'Στοιχεία Εκκίνησης Καταχώρισης Συλλογής',
    content: step1Form,
    icon: <House/>
  };

  return [ step1 ];
};